import { ICommand, IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { STCSchedulingConfigModel } from '../models/stc_scheduling_config_model';

export interface IHttp extends ng.IHttpService {
  url: string;
  method: string;
  apiVersion: string;
}

export type LoadStcScheduleConfigCommand = () => ng.IPromise<void>;

// Deprecated: this command is no longer needed because v3_student_scheduler_flag will always be true. Next step would be removing this command after all mentions of v3_student_scheduler_flag are removed from SGD.
angular
  .module('data-ng-custom-text')
  .factory(
    'loadStcScheduleConfigCommand',
    (defineCommand: IDefineCommand, ngStcSchedulingConfigModel: STCSchedulingConfigModel): ICommand => {
      return defineCommand('loadStcScheduleConfigCommand', (deferred: ng.IDeferred<any>): void => {
        ngStcSchedulingConfigModel.write({
          v3_student_scheduler_flag: true
        });
        deferred.resolve();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/commands/load_stc_schedule_config_command.ts